'use strict';
let ua = window.ua || {};

ua.name = navigator.userAgent.toLowerCase();
ua.isIE = (ua.name.indexOf('msie') >= 0 || ua.name.indexOf('trident') >= 0);
ua.isiPhone = ua.name.indexOf('iphone') >= 0;
ua.isiPod = ua.name.indexOf('ipod') >= 0;
ua.isiPad = ua.name.indexOf('ipad') >= 0;
ua.isiOS = (ua.isiPhone || ua.isiPod || ua.isiPad);
ua.isAndroid = ua.name.indexOf('android') >= 0;
ua.isTablet = (ua.isiPad || (ua.isAndroid && ua.name.indexOf('mobile') < 0));
ua.isWindows = ua.name.indexOf('windows') >= 0;
ua.isFirefox = ua.name.indexOf('firefox') >= 0;
ua.isEdge = ua.name.indexOf('edge') >= 0;
ua.isSafari = ua.name.indexOf('safari') >= 0;

ua.isMac = navigator.platform.toLowerCase().indexOf('mac') >= 0;

//console.log(ua.isWindows);
if (ua.isIE) {
    ua.verArray = /(msie|rv:?)\s?([0-9]{1,})([\.0-9]{1,})/.exec(ua.name);
    if (ua.verArray) {
        ua.ver = parseInt(ua.verArray[2], 10);
    }
}
if (ua.isiOS) {
    ua.verArray = /(os)\s([0-9]{1,})([\_0-9]{1,})/.exec(ua.name);
    if (ua.verArray) {
        ua.ver = parseInt(ua.verArray[2], 10);
    }
}
if (ua.isAndroid) {
    ua.verArray = /(android)\s([0-9]{1,})([\.0-9]{1,})/.exec(ua.name);
    if (ua.verArray) {
        ua.ver = parseInt(ua.verArray[2], 10);
    }
}


let os = 'unknown';
let clientStrings = [
  {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
  {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
  {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
  {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
  {s:'Windows Vista', r:/Windows NT 6.0/},
  {s:'Windows Server 2003', r:/Windows NT 5.2/},
  {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
  {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
  {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
  {s:'Windows 98', r:/(Windows 98|Win98)/},
  {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
  {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
  {s:'Windows CE', r:/Windows CE/},
  {s:'Windows 3.11', r:/Win16/},
  {s:'Android', r:/Android/},
  {s:'Open BSD', r:/OpenBSD/},
  {s:'Sun OS', r:/SunOS/},
  {s:'Linux', r:/(Linux|X11)/},
  {s:'iOS', r:/(iPhone|iPad|iPod)/},
  {s:'Mac OS X', r:/Mac OS X/},
  {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
  {s:'QNX', r:/QNX/},
  {s:'UNIX', r:/UNIX/},
  {s:'BeOS', r:/BeOS/},
  {s:'OS/2', r:/OS\/2/},
  {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
];
for (const id in clientStrings) {
  const cs = clientStrings[id];
  if (cs.r.test(navigator.userAgent)) {
    os = cs.s;
    break;
  }
}
ua.osName = os;

// browser
let nAgt = navigator.userAgent;
let browser = navigator.appName;
let version = '' + parseFloat(navigator.appVersion);
let nameOffset, verOffset;

// Opera
if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
  browser = 'Opera';
  version = nAgt.substring(verOffset + 6);
  if ((verOffset = nAgt.indexOf('Version')) !== -1) {
    version = nAgt.substring(verOffset + 8);
  }
}
// Opera Next
if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
  browser = 'Opera';
  version = nAgt.substring(verOffset + 4);
}
// Edge
else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
  browser = 'Microsoft Edge';
  version = nAgt.substring(verOffset + 5);
}
// MSIE
else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
  browser = 'Microsoft Internet Explorer';
  version = nAgt.substring(verOffset + 5);
}
// Chrome
else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
  browser = 'Chrome';
  version = nAgt.substring(verOffset + 7);
}
// Safari
else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
  browser = 'Safari';
  version = nAgt.substring(verOffset + 7);
  if ((verOffset = nAgt.indexOf('Version')) !== -1) {
    version = nAgt.substring(verOffset + 8);
  }
}
// Firefox
else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
  browser = 'Firefox';
  version = nAgt.substring(verOffset + 8);
}
// MSIE 11+
else if (nAgt.indexOf('Trident/') !== -1) {
  browser = 'Microsoft Internet Explorer';
  version = nAgt.substring(nAgt.indexOf('rv:') + 3);
}
// Other browsers
else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
  browser = nAgt.substring(nameOffset, verOffset);
  version = nAgt.substring(verOffset + 1);
  if (browser.toLowerCase() === browser.toUpperCase()) {
    browser = navigator.appName;
  }
}
ua.browser = browser;
ua.browserVersion = version;

module.exports = ua;
